import React, { FC, PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/UserContext";

export const AuthProtectedPage: FC<PropsWithChildren> = ({ children }) => {

    const { isLoggedIn } = useAuth();

    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn === undefined) return;
        if (!isLoggedIn) {
            navigate('/', { replace: true });
        }
    }, [isLoggedIn])



    return (
       isLoggedIn === undefined
       ?
       null
       : 
       <>{children}</>
    )
}